const theme = {
  "mebm-white": "#FFFFFF",
  "mebm-black": "#3B3B3B",
  "mebm-green": "#82b73e",
  "mebm-orange": "#fa8a27",
  "mebm-blue": "#168dc7",
  "mebm-dark-grey": "#313131",
  "mebm-light-grey": "#d4d4d4",

  "mebm-breakpoint-xs": "0",
  "mebm-breakpoint-sm": "576px",
  "mebm-breakpoint-md": "768px",
  "mebm-breakpoint-lg": "992px",
  "mebm-breakpoint-xl": "1200px",
};

module.exports = theme;
